<template>
  <div :dir="getLanguageDirection"  >
    <div :class="[overrideColor,'fluid-container','footer']">
      <div class="row">
        <div class="col-1"></div>
        <div class="col-11"><p>{{$t('msg.copyright')}}</p></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      overrideColor: ''
    }
  },
  created: function () {
    if (this.$cookies.get('override_color') && this.$cookies.get('override_color').trim() !== '') {
      this.overrideColor = this.$cookies.get('override_color')
    }
  }
}
</script>

<style>
  .fluid-container.footer {
    background: blue;
  }

  .bnm.fluid-container.footer {
    background: #0A317A;
  }

  .fluid-container.footer > *:last-child {
    margin-bottom: 0;
    color: white;
    height: 50px;
    padding-top: 10px;
    background: #1989e8;
  }

  .bnm.fluid-container.footer > *:last-child {
    margin-bottom: 0;
    color: white;
    height: 50px;
    padding-top: 10px;
    background: #0A317A;
  }
</style>
